import React from 'react';
import PropTypes from 'prop-types';
import { ExpansionPanel } from '@finn-no/troika-react-expansion-panel';

export const FilterGroup = ({ title, children, testId, expanded, showOnMobile }) => (
    <ExpansionPanel
        className={`custom-expansion-panel u-ma0${showOnMobile ? '' : ' hidden-expand-collapse--lt768'}`}
        title={title}
        headingLevel={3}
        expanded={expanded}
        bleed
        data-testid={testId}>
        {children}
    </ExpansionPanel>
);

FilterGroup.defaultProps = {
    expanded: true,
    showOnMobile: true,
};

FilterGroup.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    expanded: PropTypes.bool,
    testId: PropTypes.string,
    showOnMobile: PropTypes.bool,
};

export default React.memo(FilterGroup);
